import { DatePicker, Table } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { columns } from "../utils/reportBilling";
import '../styles/CashflowUI.scss';
import { useExportXLSX } from "../../../hooks/useExportXLSX";
import { useDispatch, useSelector } from "react-redux";
import { getReportBillingThunk, selectReportBilling } from "../CashflowSlice";
const { RangePicker } = DatePicker;

const CashReportBilling = () => {
  const dispatch = useDispatch()
  const historyBilling = useSelector(selectReportBilling)
  const today = moment.tz("America/El_Salvador");
  const {processFile} = useExportXLSX()
  const [beginDate, handleBeginDate] = useState(
    moment.tz('America/El_Salvador').startOf('month')
  );
  
  console.log(historyBilling)
 
  const [endDate, handleEndDate] = useState(today);
  const handleDates = async (values) => {
    console.log(values)
     if(values.length === 2){
      const dateInitial = values[0].format('YYYY/MM/DD 00:00:00')
      const dateEnd = values[1].format('YYYY/MM/DD 23:59:59')
      console.log(dateInitial)
      console.log(dateEnd)

     dispatch(getReportBillingThunk({dateInitial:dateInitial,dateEnd:dateEnd}))
 
     }
     
  }
  const exportData = () => {
    const sheetName = 'Facturación'

    const columnsFile = [...columns].map((item)=> item.title.replace('\u00A0',' '))
    const data = []
    historyBilling.forEach((item)=> {
       const row = [
        ...Object.values(item)
       ]
       data.push(row)
     })
    processFile(sheetName,columnsFile,data,'reportfacturacion')
  }
  return (
    <div className="cashflow-wrap">
      <div className="main-titles">
        <div>
          <h1 className="title">Reporte para facturación</h1>
          <h3 className="subtitle"> {today.format("dddd D [de] MMMM")}</h3>
        </div>
      </div>
      <div className="actions-wrap">

      
      <div className="filters-wrap-actions actions">
      <RangePicker
               
              disabled={false}
              size="large"
              placeholder={['Fecha Inicio', 'Fecha Final']}
              allowClear={false}
              value={[beginDate, endDate]}
              onChange={handleDates}
            />
        <button  className="action green" onClick={exportData}>
            Exportar
        </button>
      </div>
      </div>
      <div className="report-wrap">
        <Table columns={columns} dataSource={historyBilling} loading={false} pagination={{position:'left'}} />
      </div>
    </div>
  );
};

export default CashReportBilling;
